import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Box, Grid, makeStyles, Typography } from "@material-ui/core";

import { CLICKING } from "..";
import { COLORS } from "../../../../../theme/colors";
import { TextInput } from "../../../../../components/base";
import phoneImg from "../../../../../assets/images/icons/phone.svg";
import emailImg from "../../../../../assets/images/icons/email.svg";
import userImg from "../../../../../assets/images/icons/user.svg";
import companyImg from "../../../../../assets/images/icons/company.svg";
import endPoints from "../../../../../services/apiEndPoints";
import { getData, putData } from "../../../../../services";

const useStyles = makeStyles(() => ({
  heading: {
    fontSize: 30,
    fontWeight: 700,
  },
  input: {
    width: 300,
    marginTop: 10,
    background: COLORS.white,
  },
  paper: {
    fontSize: 18,
    marginTop: 12,
  },
  pmcDiv: {
    marginTop: 50,
  },
  morePmc: {
    color: COLORS.purple,
    fontSize: 14,
    marginTop: 30,
    cursor: "pointer",
  },
  applyPmc: {
    marginTop: 20,
    marginLeft: 10,
    color: COLORS.purple,
  },
}));

const PmcData = ({ building, handleNext, clicking, setClicking, setLoading, onError }) => {
  const classes = useStyles();

  const apiUrl = endPoints.OB_OPERATOR_PMC_INFO.replace("{id}", building.id);
  const [pmcs, setPmcs] = useState([{}]);
  const currencySymbol = useSelector((state) => state.auth.user.currency.symbol);

  useEffect(() => {
    setLoading(true);
    getData(apiUrl, (d) => {
      if (Array.isArray(d) && d.length) {
        setPmcs(d);
      }
    })
      .catch(onError)
      .finally(() => setLoading(false));
  }, [building]);

  useEffect(() => {
    if (clicking === CLICKING.none) return;
    setLoading(true);
    putData(
      apiUrl,
      () => {
        if (clicking === CLICKING.next) {
          setClicking(CLICKING.none);
        }
        handleNext();
      },
      pmcs
    )
      .catch(onError)
      .finally(() => {
        setLoading(false);
        setClicking(CLICKING.none);
      });
  }, [clicking]);

  const onDataChange = (index, key, value) => {
    pmcs[index] = { ...pmcs[index], [key]: value };
    setPmcs([...pmcs]);
  };

  return (
    <Box>
      <Typography className={classes.heading}>Great. Who manages the building?</Typography>
      <Box className={classes.pmcDiv}>
        {pmcs.map((pmc, i) => (
          <Grid key={i} container spacing={3}>
            <Grid item xs={3}>
              <Typography className={classes.paper}>Building PMC:</Typography>
            </Grid>
            <Grid item xs={9}>
              <Box display="flex">
                <TextInput
                  id="Campany-input"
                  fullWidth
                  value={pmc.company_name}
                  onChange={(v) => onDataChange(i, "company_name", v)}
                  placeHolder="Company name"
                  containerStyle={classes.input}
                  startAdornment={<img src={companyImg} alt="company-icon" />}
                />
                <Typography className={classes.applyPmc}>
                  Apply PMC details to the entire portfolio
                </Typography>
              </Box>
              <TextInput
                id="Contact-input"
                fullWidth
                value={pmc.contact_name}
                onChange={(v) => onDataChange(i, "contact_name", v)}
                placeHolder="Contact name"
                containerStyle={classes.input}
                startAdornment={<img src={userImg} alt="lock-icon" />}
              />
              <TextInput
                id="email-input"
                fullWidth
                value={pmc.email}
                onChange={(v) => onDataChange(i, "email", v)}
                placeHolder="Email"
                containerStyle={classes.input}
                startAdornment={<img src={emailImg} alt="lock-icon" />}
              />
              <TextInput
                id="number-input"
                fullWidth
                value={pmc.phone_number}
                onChange={(v) => onDataChange(i, "phone_number", v)}
                placeHolder="Contact number"
                containerStyle={classes.input}
                startAdornment={<img src={phoneImg} alt="lock-icon" />}
              />
              <TextInput
                id="Fee-input"
                fullWidth
                type="number"
                value={pmc.fee}
                onChange={(v) => onDataChange(i, "fee", v)}
                placeHolder={`Fee (% or ${currencySymbol})`}
                containerStyle={classes.input}
              />
            </Grid>
          </Grid>
        ))}
      </Box>
      <Typography className={classes.morePmc} onClick={() => setPmcs([...pmcs, {}])}>
        + Add another PMC
      </Typography>
    </Box>
  );
};

export default PmcData;
